import React from "react";
import SubVendorTypeSection from "./subVendorType/SubVendorTypeSection";
import PaymentTermsSection from "../clientConfig/paymentTerms/PaymentTermsSection";
import SubVendorCategorySelection from "./subVendorCategory/SubVendorCategorySelection";
import PaymentScheduleSelection from "./paymentSchedule/PaymentScheduleSelection";

const SubVendorConfigSection = ({ userDetails, selectedClient }) => {
  return (
    <div className='grid-container'>
      <SubVendorTypeSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <PaymentTermsSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <SubVendorCategorySelection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <PaymentScheduleSelection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
    </div>
  );
};

export default SubVendorConfigSection;
